import store from './store';
import { isCustomDomain, resolveCustomDomainShop } from './views/public/custom_domain';

/** Resolve shop slug from custom domain before Vue mounts. */
export default async function initCustomDomain() {
  if (!isCustomDomain()) return null;
  try {
    const shop = await resolveCustomDomainShop(process.env.VUE_APP_API_URL || '');
    if (shop?.slug) {
      store.commit('public_shop/SET_CUSTOM_DOMAIN_SLUG', shop.slug);
      if (shop.theme_color) {
        document.documentElement.style.setProperty('--theme-color', shop.theme_color);
      }
      return shop;
    }
  } catch (e) {
    console.warn('[custom_domain] resolve failed', e);
  }
  return null;
}
